import PropTypes from 'prop-types';

//placeholder for components

export const  ComponentType = PropTypes.object;